<div class="timer">
  <div class="timer-tick">
    <div class="timer-digits text-left">
      <div class="timer-digit-group">
        <div class="timer-digit" id="days">{{ _days || 0 }}</div>
        <div class="timer-colon">:</div>
        <p class="timer-unit">DIAS</p>
      </div>
      <div class="timer-digit-group">
        <div class="timer-digit" id="hours">{{ _hours || 0 }}</div>
        <div class="timer-colon">:</div>
        <p class="timer-unit">HORAS</p>
      </div>
      <div class="timer-digit-group">
        <div class="timer-digit" id="minutes">{{ _minutes || 0 }}</div>
        <div class="timer-colon">:</div>
        <p class="timer-unit">MINUTOS</p>
      </div>
      <div class="timer-digit-group">
        <div class="timer-digit" id="seconds">{{ _seconds || 0 }}</div>
        <p class="timer-unit">SEGUNDOS</p>
      </div>
    </div>
  </div>
</div>
